import { links } from '../../../../constants/links';

const { houses, tenants, personalAccounts, exports, imports, reportRSO } = links;

export const menu = [
  {
    key: houses,
    content: 'Дома',
  },
  {
    key: tenants,
    content: 'Жители',
  },
  {
    key: personalAccounts,
    content: 'Лицевые счета',
  },
  {
    key: exports,
    content: 'Отчеты',
  },
  {
    key: imports,
    content: 'Импорт',
  },
    {
    key: reportRSO,
    content: 'Отчет в РСО',
  },
];
